// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LYdy","name":"Header_name__1xMP1","birthday":"Header_birthday__ukquP","skeleton":"Header_skeleton__2c7hK"};